import type { ComponentConfig } from '@measured/puck';
import { Container } from '../layout/Container';

export interface QuoteProps {
  text: string;
  author?: string;
}

export function Quote({ text, author }: QuoteProps) {
  return (
    <section className="bg-white py-16">
      <Container className="max-w-3xl text-center">
        <blockquote className="font-display text-2xl leading-snug text-stone-900 md:text-3xl">
          « {text} »
        </blockquote>
        {author ? <p className="mt-4 text-sm text-stone-500">— {author}</p> : null}
      </Container>
    </section>
  );
}

export const QuoteConfig: ComponentConfig<QuoteProps> = {
  fields: { text: { type: 'textarea' }, author: { type: 'text' } },
  defaultProps: { text: 'La transition énergétique se fait par la documentation, pas par les promesses.', author: '' },
  render: Quote,
};
